import {
  FETCH_START,
  FETCH_END,
  PROMOTION_DATA_SUCCESS,
  PROMO_FINANCE_COST_DATA_SUCCESS,
  FINANCE_TERM_SPLIT_DATA_SUCCESS,
  FINANCE_GROUP_RATES_DATA_SUCCESS,
  PROMO_TERRITORY_DATA_SUCCESS,
  PROMO_TERRITORY_FORMAT_SUCCESS,
  PROMO_TERRITORY_FORMAT_BY_ID_SUCCESS,
  PROMO_TERRITORY_FORMAT_FIELDS_SUCCESS,
  PROMO_TERRITORY_UPLOAD_SUCCESS,
  PROMO_FINANCE_COST_DETAIL_SUCCESS,
  PROMO_FINANCE_TERM_SPLIT_DETAIL_SUCCESS,
  PROMO_FINANCE_GROUP_RATES_DETAIL_SUCCESS,
  FINANCE_COST_FORMAT_SUCCESS,
  FINANCE_TERM_SPLIT_FORMAT_SUCCESS,
  FINANCE_GROUP_RATE_FORMAT_SUCCESS,
  FINANCE_COST_FORMAT_BY_ID_SUCCESS,
  FINANCE_COST_FORMAT_FIELDS_SUCCESS,
  FINANCE_TERM_SPLIT_FORMAT_FIELDS_SUCCESS,
  FINANCE_GROUP_RATES_FORMAT_FIELDS_SUCCESS,
  PROMO_FINANCE_COST_UPLOAD_SUCCESS,
  PROMO_FINANCE_TERM_SPLIT_UPLOAD_SUCCESS,
  PROMO_FINANCE_GROUP_RATE_UPLOAD_SUCCESS,
  COUNTRY_SUCCESS,
  TERRITORY_ID_SUCCESS,
  PROMO_MAP_SUCCESS,
  PROMO_MAP_SINGLE_SUCCESS,
  PROMO_MAPPING_FORMAT_SUCCESS,
  PROMO_MAP_FORMAT_BY_ID,
  PROMO_MAP_FORMAT_FIELDS,
  PROMO_TYPES,
  PROMO_STICKERS,
  PROMO_STICKER_BY_ID,
  CLEAR_PROMO_STICKER_BY_ID,
  MARKET_FILTERS,
  PROMO_FILTERS,
  MODEL_GROUP,
  LOCATION_GROUP,
  MODEL_LIST_GROUP,
  PROMO_CONFIG_UPLOAD_SUCCESS,
  PROMO_CONFIG_FORMAT_FIELDS_SUCCESS,
  PROMO_CONFIG_FORMAT_SUCCESS,
  PROMO_CONFIG_DATA_SUCCESS,
  MATERIAL_PRICING_UPLOAD_SUCCESS,
  MATERIAL_PRICING_FORMAT_FIELDS_SUCCESS,
  MATERIAL_PRICING_FORMAT_SUCCESS,
  MATERIAL_PRICING_DATA_SUCCESS,
  MATERIAL_PRICING_SINGLE_DATA_SUCCESS,
  PROMO_CONFIG_SINGLE_DATA_SUCCESS,
  SCENARIO_LIST_DATA_SUCCESS,
  HISTORY_DATA_SUCCESS,
  SAND_BOX_DATA_SUCCESS,
  PROMOTIONS_SEARCH_SUCCESS,
  COSTING_START,
  COSTING_END,
  PREFILL_SCENARIO_SUCCESS,
  SCENARIO_BY_ID,
  COVERAGE_MAPPING_UPLOAD_SUCCESS,
  COVERAGE_MAPPING_FORMAT_FIELDS_SUCCESS,
  COVERAGE_MAPPING_FORMAT_SUCCESS,
  COVERAGE_MAPPING_DATA_SUCCESS,
  COVERAGE_MAPPING_SINGLE_SUCCESS,
  STANDARD_FINANCE_UPLOAD_SUCCESS,
  STANDARD_FINANCE_FORMAT_FIELDS_SUCCESS,
  STANDARD_FINANCE_FORMAT_SUCCESS,
  STANDARD_FINANCE_DATA_SUCCESS,
  STANDARD_FINANCE_SINGLE_DATA_SUCCESS,
  PROMOTION_CURRENCY_UPLOAD_SUCCESS,
  PROMOTION_CURRENCY_FORMAT_FIELDS_SUCCESS,
  PROMOTION_CURRENCY_FORMAT_SUCCESS,
  PROMOTION_CURRENCY_DATA_SUCCESS,
  PROMOTION_CURRENCY_SINGLE_SUCCESS,
  SAVED_SCENARIO,
  SALES_FORECAST_SINGLE_DATA_SUCCESS,
  SCENARIO_MARKETS,
  PREVIOUS_SCENARIO,
  REVIEW_SCENARIO,
  CURRENT_SCENARIO,
  MARKET_END,
  MARKET_START,
  CUSTOM_GROUP_ID,
  CUSTOM_GROUPS,
  CUSTOM_GROUP_LIST,
  TR_APPROVAL_DATA_SUCCESS,
  MULTI_PROMO_SEARCH_SUCCESS,
  TR_APPROVAL_REVIEW_DATA_SUCCESS,
  TR_APPROVAL_REVIEW_COMPLETED_DATA_SUCCESS,
  GROUPED_CUSTOM_GROUP,
  PROMOTION_COSTING_COMPARISON_UPLOAD_SUCCESS,
  PROMO_COSTING_DROPDOWN_DATA_SUCCESS,
  ARCHIVE,
  STICKER_ARCHIVE,
  PROMO_COSTING_TABLE_DATA_SUCCESS,
  LOCATION_FILTER,
  SCENARIO_DATA,
  GRID_DATA,
  USER_ACCESS_DATA,
  CURRENT_MODEL_YEAR,
  CLEAR_DATA,
  PROMO_FINANCE_COSTING_DIALOG_DATA_SUCCESS,
  PROMO_PROMOTIONAL_OFFERS_DATA_SUCCESS,
  PROMO_REGULAR_OFFERS_DATA_SUCCESS,
  PROMO_REGULAR_OFFERS_UPLOAD_SUCCESS,
  PROMO_REGULAR_OFFERS_FORMAT_SUCCESS,
  PROMO_REGULAR_OFFERS_FIELDS_SUCCESS,
  PROMO_REGULAR_FINANCING_DATA_SUCCESS,
  DOWNLOADING, VALID_MARKETS,
  PROMO_COMMENT_DIALOG_DATA_SUCCESS,
  MANUAL_UPLOAD_FORMAT_DATA,
  MANUAL_FIELD_SUCCESS,
  MANUAL_PROMO_SUCCESS,
  MANUAL_PROMO_BY_ID,
  PROMO_COSTING_ANALYSIS_DATA_SUCCESS,
  PROMO_FIN_EXCEPTION_SCENARIO_SUCCESS,
  PROMO_BUDGET_DATA_SUCCESS, BUDGET_LIST_DATA_SUCCESS,
  BUDGET_STICKER_CLONED_DATA, BUDGET_VOLUME_DATA_SUCCESS,
  BUDGET_SALES_FORECAST_DATA_SUCCESS,
  BUDGET_SALES_FORECAST_SINGLE_DATA_SUCCESS,
  BUDGET_PREFILL_LIST_DATA_SUCCESS, PROMO_BUDGET_PREFILL_DATA_SUCCESS,
  BUDGET_REPORTING_DATA_SUCCESS,
  TEMP_PROMO_BUDGET_DATA_SUCCESS,
  APPROVED_SCENARIO_LIST_SUCCESS,
  PROMO_SIGNATURE_CONFIG_LIST_SUCCESS,
  PROMO_SIGNATURE_CONFIG_BY_ID_SUCCESS,
  PROMO_MATERIAL_MASTER_DETAIL_SUCCESS,
} from '../../actions/Promotion/ActionTypes';
import { downloading } from '../../actions/Promotion/AuthAction';

const initialState = {
  loading: false,
  promotionData: [],
  promoFinanceCostData: [],
  promoFinanceTermSplitData: [],
  promoFinanceGroupRatesData: [],
  promoTerritoryData: [],
  promoTerritorySingleFormatData: [],
  promoTerritoryFormatFieldData: [],
  promoTerritoryFormatData: [],
  promoTerritory: [],
  promoTerritoryErrorList: [],
  promoFinanceCostDetailsData: [],
  promoFinanceTermSplitDetailsData: [],
  promoFinanceGroupRatesDetailsData: [],
  promoFinanceCostSingleFormatData: [],
  promoFinanceCostFormatFieldData: [],
  promoFinanceTermSplitFormatFieldData: [],
  promoFinanceGroupRatesFormatFieldData: [],
  promoFinanceCostFormatData: [],
  promoFinanceTermSplitFormatData: [],
  promoFinanceGroupRateFormatData: [],
  promoFinanceCost: [],
  promoFinanceCostErrorList: [],
  promoFinanceTermSplitErrorList: [],
  promoFinanceGroupRateErrorList: [],
  countryData: [],
  territoryIdData: [],
  promoMapData: [],
  promoMapSingleData: [],
  promoMapFormatData: [],
  promoMapFormatFields: [],
  promoMapFormatSingleData: [],
  promoTypes: {},
  promoStickers: [],
  stickerData: {},
  marketFilters: [],
  promoFilters: [],
  modelFilters: [],
  locationFilters: [],
  modelList: [],
  promoConfigErrorList: [],
  promoConfigField: [],
  promoConfigFormatData: [],
  promoConfigData: [],
  promoConfigDataSingle: [],
  materialPricingErrorList: [],
  materialPricingField: [],
  materialPricingFormatData: [],
  materialPricingData: [],
  materialPricingDataSingle: [],
  promotionsSearchData: [],
  oncostingLoad: false,
  prefillScenarioList: [],
  //scenarioPayload: [],
  scenarioData: [],
  scenarioListData: [],
  sandBoxListData: [],
  historyListData: [],
  coverageMappingFormatData: [],
  coverageMappingErrorList: [],
  coverageMappingField: [],
  coverageMappingListData: [],
  coverageMappingDataSingle: [],
  standardFinanceFormatData: [],
  standardFinanceErrorList: [],
  standardFinanceField: [],
  standardFinanceListData: [],
  standardFinanceDataSingle: [],
  promotionCurrencyFormatData: [],
  promotionCurrencyErrorList: [],
  promotionCurrencyField: [],
  promotionCurrencyListData: [],
  promotionCurrencyDataSingle: [],
  savedScenario: {},
  salesForecastDataSingle: [],
  scenarioMarkets: [],
  previousScenario: [],
  reviewScenario: [],
  currentScenarioList: [],
  trApprovalReviewData: [],
  trApprovalData: [],
  trApprovalReviewCompletedData: [],
  marketloading: false,
  marketcompare: false,
  customGroups: [],
  customGroupById: {},
  customGroupList: [],
  groupedCustom: {},
  costingComparisonDownload: [],
  costingDropdownData: [],
  archiveList: [],
  stickerArchiveList: [],
  costingTableData: [],
  filteredLocation: [],
  gridData: {},
  userAccessData: [],
  gridLoader: false,
  Scenarioloader: false,
  currentModelYear: [],
  financeCostingDialog: [],
  promotionalOffers: [],
  regularOffers: [],
  regularOffersFormatData: [],
  regularOffersErrorList: [],
  regularOffersFormatFieldData: [],
  regularFinancingData: [],
  downloading: false,
  validMarkets: {},
  commentData: [],
  manualFormatData: [],
  manualFormatFeildData: [],
  manaualPromoData: [],
  manualPromoDataById: [],
  promoSignatureConfigList: [],
  promoSignatureConfigById: {},
  promoCostingAnalysisData: [],
  tableLoader: false,
  promoFinExceptionScenarioData: [],
  promoBudgetData: {},
  promoBudgetError: false,
  promoBudgetLoader: false,
  promoBudgetListData: [],
  promoBudgetPrefillData: {},
  promoBudgetPrefillListData: [],
  promoBudgetClonedID: null,
  promoBudgetVolumeData: [],
  budgetSalesForecastData: [],
  budgetSalesForecastDataSingle: [],
  budgetReportingCostDetails: [],
  approvedScenarioList: [],
  promoMaterialMasterDetail: {},
};


const PromotionReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_START:
      return {
        ...state,
        loading: true,
      };
    case FETCH_END:
      return {
        ...state,
        loading: false,
      };
    case PROMOTION_DATA_SUCCESS:
      return {
        ...state,
        promotionData: action.data,
      };
    case PROMO_FINANCE_COST_DATA_SUCCESS:
      return {
        ...state,
        promoFinanceCostData: action.data,
      };
    case FINANCE_TERM_SPLIT_DATA_SUCCESS:
      return {
        ...state,
        promoFinanceTermSplitData: action.data,
      };
    case FINANCE_GROUP_RATES_DATA_SUCCESS:
      return {
        ...state,
        promoFinanceGroupRatesData: action.data,
      };
    case PROMO_TERRITORY_DATA_SUCCESS:
      return {
        ...state,
        promoTerritoryData: action.data,
      };
    case PROMO_TERRITORY_FORMAT_SUCCESS:
      return {
        ...state,
        promoTerritoryFormatData: action.data,
      };
    case PROMO_TERRITORY_FORMAT_FIELDS_SUCCESS:
      return {
        ...state,
        promoTerritoryFormatFieldData: action.data,
      };
    case PROMO_TERRITORY_UPLOAD_SUCCESS:
      return {
        ...state,
        promoTerritoryErrorList: action.data,
      };
    case PROMO_TERRITORY_FORMAT_BY_ID_SUCCESS:
      return {
        ...state,
        promoTerritorySingleFormatData: action.data,
      };
    case PROMO_FINANCE_COST_DETAIL_SUCCESS:
      return {
        ...state,
        promoFinanceCostDetailsData: action.data,
      };
    case PROMO_FINANCE_TERM_SPLIT_DETAIL_SUCCESS:
      return {
        ...state,
        promoFinanceTermSplitDetailsData: action.data,
      };
    case PROMO_FINANCE_GROUP_RATES_DETAIL_SUCCESS:
      return {
        ...state,
        promoFinanceGroupRatesDetailsData: action.data,
      };
    case FINANCE_COST_FORMAT_SUCCESS:
      return {
        ...state,
        promoFinanceCostFormatData: action.data,
      };
    case FINANCE_TERM_SPLIT_FORMAT_SUCCESS:
      return {
        ...state,
        promoFinanceTermSplitFormatData: action.data,
      };
    case FINANCE_GROUP_RATE_FORMAT_SUCCESS:
      return {
        ...state,
        promoFinanceGroupRateFormatData: action.data,
      };
    case FINANCE_COST_FORMAT_FIELDS_SUCCESS:
      return {
        ...state,
        promoFinanceCostFormatFieldData: action.data,
      };
    case FINANCE_TERM_SPLIT_FORMAT_FIELDS_SUCCESS:
      return {
        ...state,
        promoFinanceTermSplitFormatFieldData: action.data,
      };
    case FINANCE_GROUP_RATES_FORMAT_FIELDS_SUCCESS:
      return {
        ...state,
        promoFinanceGroupRatesFormatFieldData: action.data,
      };
    case FINANCE_COST_FORMAT_BY_ID_SUCCESS:
      return {
        ...state,
        promoFinanceCostSingleFormatData: action.data,
      };
    case PROMO_FINANCE_COST_UPLOAD_SUCCESS:
      return {
        ...state,
        promoFinanceCostErrorList: action.data,
      };
    case PROMO_FINANCE_TERM_SPLIT_UPLOAD_SUCCESS:
      return {
        ...state,
        promoFinanceTermSplitErrorList: action.data,
      };
    case PROMO_FINANCE_GROUP_RATE_UPLOAD_SUCCESS:
      return {
        ...state,
        promoFinanceGroupRateErrorList: action.data,
      };
    case COUNTRY_SUCCESS:
      return {
        ...state,
        countryData: action.data,
      };
    case TERRITORY_ID_SUCCESS:
      return {
        ...state,
        territoryIdData: action.data,
      };
    case PROMO_MAP_SUCCESS:
      return {
        ...state,
        promoMapData: action.data,
      };
    case PROMO_MAP_SINGLE_SUCCESS:
      return {
        ...state,
        promoMapSingleData: action.data,
      };
    case PROMO_MAPPING_FORMAT_SUCCESS:
      return {
        ...state,
        promoMapFormatData: action.data,
      };
    case PROMO_MAP_FORMAT_BY_ID:
      return {
        ...state,
        promoMapFormatSingleData: action.data,
      };
    case PROMO_MAP_FORMAT_FIELDS:
      return {
        ...state,
        promoMapFormatFields: action.data,
      };
    case PROMO_TYPES:
      return {
        ...state,
        promoTypes: action.data,
      };
    case PROMO_STICKERS:
      return {
        ...state,
        promoStickers: action.data,
      };
    case PROMO_STICKER_BY_ID:
      return {
        ...state,
        stickerData: action.data,
      };
    case CLEAR_PROMO_STICKER_BY_ID:
      return {
        ...state,
        stickerData: {},
      };
    case STICKER_ARCHIVE:
      return {
        ...state,
        stickerArchiveList: action.data,
      };
    case PROMO_FILTERS:
      return {
        ...state,
        promoFilters: action.data,
      };
    case MARKET_FILTERS:
      return {
        ...state,
        marketFilters: action.data,
      };
    case MODEL_GROUP:
      return {
        ...state,
        modelFilters: action.data,
      };
    case LOCATION_GROUP:
      return {
        ...state,
        locationFilters: action.data,
      };
    case MODEL_LIST_GROUP:
      return {
        ...state,
        modelList: action.data,
      };
    case PROMO_CONFIG_UPLOAD_SUCCESS:
      return {
        ...state,
        promoConfigErrorList: action.data,
      };
    case PROMO_CONFIG_FORMAT_FIELDS_SUCCESS:
      return {
        ...state,
        promoConfigField: action.data,
      };
    case PROMO_CONFIG_FORMAT_SUCCESS:
      return {
        ...state,
        promoConfigFormatData: action.data,
      };
    case PROMO_CONFIG_DATA_SUCCESS:
      return {
        ...state,
        promoConfigData: action.data,
      };
    case PROMO_CONFIG_SINGLE_DATA_SUCCESS:
      return {
        ...state,
        promoConfigDataSingle: action.data,
      };
    case MATERIAL_PRICING_UPLOAD_SUCCESS:
      return {
        ...state,
        materialPricingErrorList: action.data,
      };
    case MATERIAL_PRICING_FORMAT_FIELDS_SUCCESS:
      return {
        ...state,
        materialPricingField: action.data,
      };
    case MATERIAL_PRICING_FORMAT_SUCCESS:
      return {
        ...state,
        materialPricingFormatData: action.data,
      };
    case MATERIAL_PRICING_DATA_SUCCESS:
      return {
        ...state,
        materialPricingData: action.data,
      };
    case MATERIAL_PRICING_SINGLE_DATA_SUCCESS:
      return {
        ...state,
        materialPricingDataSingle: action.data,
      };
    case PROMOTIONS_SEARCH_SUCCESS:
      return {
        ...state,
        promotionsSearchData: action.data,
      };
    case COSTING_START:
      return {
        ...state,
        oncostingLoad: true,
      };
    case COSTING_END:
      return {
        ...state,
        oncostingLoad: false,
      };
    case PREFILL_SCENARIO_SUCCESS:
      return {
        ...state,
        prefillScenarioList: action.data,
        // scenarioPayload: action.payload
      };
    case SCENARIO_BY_ID:
      return {
        ...state,
        scenarioData: action.data,
      };
    case SCENARIO_LIST_DATA_SUCCESS:
      return {
        ...state,
        scenarioListData: action.data,
      };
    case SAND_BOX_DATA_SUCCESS:
      return {
        ...state,
        sandBoxListData: action.data,
      };
    case HISTORY_DATA_SUCCESS:
      return {
        ...state,
        historyListData: action.data,
      };

    case COVERAGE_MAPPING_UPLOAD_SUCCESS:
      return {
        ...state,
        coverageMappingErrorList: action.data,
      };
    case COVERAGE_MAPPING_FORMAT_FIELDS_SUCCESS:
      return {
        ...state,
        coverageMappingField: action.data,
      };
    case COVERAGE_MAPPING_FORMAT_SUCCESS:
      return {
        ...state,
        coverageMappingFormatData: action.data,
      };
    case COVERAGE_MAPPING_DATA_SUCCESS:
      return {
        ...state,
        coverageMappingListData: action.data,
      };
    case COVERAGE_MAPPING_SINGLE_SUCCESS:
      return {
        ...state,
        coverageMappingDataSingle: action.data,
      };
    case STANDARD_FINANCE_UPLOAD_SUCCESS:
      return {
        ...state,
        standardFinanceErrorList: action.data,
      };
    case STANDARD_FINANCE_FORMAT_FIELDS_SUCCESS:
      return {
        ...state,
        standardFinanceField: action.data,
      };
    case STANDARD_FINANCE_FORMAT_SUCCESS:
      return {
        ...state,
        standardFinanceFormatData: action.data,
      };
    case STANDARD_FINANCE_DATA_SUCCESS:
      return {
        ...state,
        standardFinanceListData: action.data,
      };
    case STANDARD_FINANCE_SINGLE_DATA_SUCCESS:
      return {
        ...state,
        standardFinanceDataSingle: action.data,
      };
    case PROMOTION_CURRENCY_UPLOAD_SUCCESS:
      return {
        ...state,
        promotionCurrencyErrorList: action.data,
      };
    case PROMOTION_CURRENCY_FORMAT_FIELDS_SUCCESS:
      return {
        ...state,
        promotionCurrencyField: action.data,
      };
    case PROMOTION_CURRENCY_FORMAT_SUCCESS:
      return {
        ...state,
        promotionCurrencyFormatData: action.data,
      };
    case PROMOTION_CURRENCY_DATA_SUCCESS:
      return {
        ...state,
        promotionCurrencyListData: action.data,
      };
    case PROMOTION_CURRENCY_SINGLE_SUCCESS:
      return {
        ...state,
        promotionCurrencyDataSingle: action.data,
      };
    case SAVED_SCENARIO:
      return {
        ...state,
        savedScenario: action.data,
      };
    case CLEAR_DATA:
      return {
        ...state,
        savedScenario: null,
        gridData: null,
      };
    case SCENARIO_DATA:
      return {
        ...state,
        savedScenario: action.data,
        Scenarioloader: action.loader,
      };
    case SALES_FORECAST_SINGLE_DATA_SUCCESS:
      return {
        ...state,
        salesForecastDataSingle: action.data,
      };
    case SCENARIO_MARKETS:
      return {
        ...state,
        scenarioMarkets: action.data,
      };
    case PREVIOUS_SCENARIO:
      return {
        ...state,
        previousScenario: action.data,
      };
    case REVIEW_SCENARIO:
      return {
        ...state,
        reviewScenario: action.data,
      };
    case CURRENT_SCENARIO:
      return {
        ...state,
        currentScenario: action.data,
      };
    case TR_APPROVAL_DATA_SUCCESS:
      return {
        ...state,
        trApprovalData: action.data,
      };
    case MULTI_PROMO_SEARCH_SUCCESS:
      return {
        ...state,
        multiPromoData: action.data,
      };
    case TR_APPROVAL_REVIEW_DATA_SUCCESS:
      return {
        ...state,
        trApprovalReviewData: action.data,
      };
    case TR_APPROVAL_REVIEW_COMPLETED_DATA_SUCCESS:
      return {
        ...state,
        trApprovalReviewCompletedData: action.data,
      };
    case MARKET_START:
      return {
        ...state,
        marketloading: true,
      };
    case MARKET_END:
      return {
        ...state,
        marketloading: false,
      };
    case CUSTOM_GROUP_ID:
      return {
        ...state,
        customGroupById: action.data,
      };
    case CUSTOM_GROUPS:
      return {
        ...state,
        customGroups: action.data,
      };
    case GROUPED_CUSTOM_GROUP:
      return {
        ...state,
        groupedCustom: action.data,
      };
    case CUSTOM_GROUP_LIST:
      return {
        ...state,
        customGroupList: action.data,
      };
    case ARCHIVE:
      return {
        ...state,
        archiveList: action.data,
      };
    case PROMOTION_COSTING_COMPARISON_UPLOAD_SUCCESS:
      return {
        ...state,
        costingComparisonDownload: action.data,
      };
    case PROMO_COSTING_DROPDOWN_DATA_SUCCESS:
      return {
        ...state,
        costingDropdownData: action.data,
      };
    case PROMO_COSTING_TABLE_DATA_SUCCESS:
      return {
        ...state,
        costingTableData: action.data,
        tableLoader: action.loader,
      };
    case LOCATION_FILTER:
      return {
        ...state,
        filteredLocation: action.data,
      };
    case GRID_DATA:
      return {
        ...state,
        gridData: action.data,
        gridLoader: action.loader,
      };
    case USER_ACCESS_DATA:
      return {
        ...state,
        userAccessData: action.data,
      };
    case CURRENT_MODEL_YEAR:
      return {
        ...state,
        currentModelYear: action.data,
      };
    case PROMO_FINANCE_COSTING_DIALOG_DATA_SUCCESS:
      return {
        ...state,
        financeCostingDialog: action.data,
      };
    case PROMO_PROMOTIONAL_OFFERS_DATA_SUCCESS:
      return {
        ...state,
        promotionalOffers: action.data,
      };
    case PROMO_REGULAR_OFFERS_DATA_SUCCESS:
      return {
        ...state,
        regularOffers: action.data,
      };
    case PROMO_REGULAR_OFFERS_UPLOAD_SUCCESS:
      return {
        ...state,
        regularOffersErrorList: action.data,
      };
    case PROMO_REGULAR_OFFERS_FORMAT_SUCCESS:
      return {
        ...state,
        regularOffersFormatData: action.data,
      };
    case PROMO_REGULAR_OFFERS_FIELDS_SUCCESS:
      return {
        ...state,
        regularOffersFormatFieldData: action.data,
      };
    case PROMO_REGULAR_FINANCING_DATA_SUCCESS:
      return {
        ...state,
        regularFinancingData: action.data,
      };
    case DOWNLOADING:
      return {
        ...state,
        downloading: action.data,
      };
    case MANUAL_UPLOAD_FORMAT_DATA:
      return {
        ...state,
        manualFormatData: action.data
      }
    case MANUAL_UPLOAD_FORMAT_DATA:
      return {
        ...state,
        manualFormatData: action.data
      }
    case MANUAL_FIELD_SUCCESS:
      return {
        ...state,
        manualFormatFeildData: action.data
      };
    case MANUAL_PROMO_SUCCESS:
      return {
        ...state,
        manaualPromoData: action.data
      }
    case MANUAL_PROMO_BY_ID:
      return {
        ...state,
        manualPromoDataById: action.data
      };
    case VALID_MARKETS:
      return {
        ...state,
        validMarkets: action.data,
      };
    case PROMO_COMMENT_DIALOG_DATA_SUCCESS:
      return {
        ...state,
        commentData: action.data,
      };
    case PROMO_COSTING_ANALYSIS_DATA_SUCCESS:
      return {
        ...state,
        promoCostingAnalysisData: action.data
      };
    case PROMO_FIN_EXCEPTION_SCENARIO_SUCCESS:
      return {
        ...state,
        promoFinExceptionScenarioData: action.data
      };
    case PROMO_BUDGET_DATA_SUCCESS:
      return {
        ...state,
        promoBudgetData: action.data,
        promoBudgetLoader: action.loader,
        promoBudgetError: action.error,
      };
    case TEMP_PROMO_BUDGET_DATA_SUCCESS:
      return {
        ...state,
        tempPromoBudgetData: action.data,
      };
    case BUDGET_LIST_DATA_SUCCESS:
      return {
        ...state,
        promoBudgetListData: action.data,
      };
    case BUDGET_PREFILL_LIST_DATA_SUCCESS:
      return {
        ...state,
        promoBudgetPrefillListData: action.data,
      };
    case PROMO_BUDGET_PREFILL_DATA_SUCCESS:
      return {
        ...state,
        promoBudgetPrefillData: action.data,
        promoBudgetLoader: action.loader
      };
    case BUDGET_STICKER_CLONED_DATA:
      return {
        ...state,
        promoBudgetClonedID: action.data,
      };
    case BUDGET_VOLUME_DATA_SUCCESS:
      return {
        ...state,
        promoBudgetVolumeData: action.data,
      };
    case BUDGET_SALES_FORECAST_DATA_SUCCESS:
      return {
        ...state,
        promotionsSearchData: action.data,
      };
    case BUDGET_SALES_FORECAST_SINGLE_DATA_SUCCESS:
      return {
        ...state,
        budgetSalesForecastDataSingle: action.data,
      };
    case BUDGET_REPORTING_DATA_SUCCESS:
      return {
        ...state,
        budgetReportingCostDetails: action.data,
      };
    case APPROVED_SCENARIO_LIST_SUCCESS:
      return {
        ...state,
        approvedScenarioList: action.data,
      };
    case PROMO_SIGNATURE_CONFIG_LIST_SUCCESS:
      return {
        ...state,
        promoSignatureConfigList: action.data,
      };
    case PROMO_SIGNATURE_CONFIG_BY_ID_SUCCESS:
      return {
        ...state,
        promoSignatureConfigById: action.data,
      };
    case PROMO_MATERIAL_MASTER_DETAIL_SUCCESS:
      return {
        ...state,
        promoMaterialMasterDetail: action.data,
      };
    default:
      return state;
  }
};

export default PromotionReducer;
